var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M915.06,894.79l-324.81-471.88L950.32,4.02h-82.37l-70.51,81.63-243.91,283.89L321.19,32l-19.26-27.97H16.43l69.63,101.19,308.93,448.86L15.31,995.98h82.37l334.03-388.6,248.22,360.65,19.26,27.95h285.5l-69.63-101.19ZM733.12,931.4l-257.88-374.68-36.72-53.34L139.28,68.61h128.72l242,351.61,36.72,53.34,315.12,457.84h-128.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4c74390d594aaaf468673b6d0640b65d.svg";
export { ForwardRef as ReactComponent };